export const name: string = 'partners';

export const types = {
    EDIT_PARTNER: name + '/EDIT_PARTNER',
    GET_PARTNER: name + '/GET_PARTNER',
    SAVE_PARTNER: name + '/SAVE_PARTNER',
    GET_PARTNER_DRIVERS: name + '/GET_PARTNER_DRIVERS',
    GET_PARTNER_VEHICLES: name + '/GET_PARTNER_VEHICLES',
    GET_PARTNER_MANAGERS: name + '/GET_PARTNER_MANAGERS',
    GET_PARTNER_BILLS_LOG: name + '/GET_PARTNER_BILLS_LOG',
    SAVE_PARTNER_VEHICLE: name + '/SAVE_PARTNER_VEHICLE',
    GET_VEHICLE_MODELS: name + '/GET_VEHICLE_MODELS',
    GET_VEHICLE_COLORS: name + '/GET_VEHICLE_COLORS',
    GET_VEHICLE_MOTORIZATIONS: name + '/GET_VEHICLE_MOTORIZATIONS',
    SAVE_PARTNER_DRIVER: name + '/SAVE_PARTNER_DRIVER',
    GET_PARTNER_MANAGER: name + '/GET_PARTNER_MANAGER',
    EDIT_PARTNER_MANAGER: name + '/EDIT_PARTNER_MANAGER',
    SAVE_PARTNER_MANAGER: name + '/SAVE_PARTNER_MANAGER',
    RESET_MANAGER_PASSWORD: name + '/RESET_MANAGER_PASSWORD',
    SAVE_ADJUSTMENT: name + '/SAVE_ADJUSTMENT',
    SAVE_PARTNERSHIP_CONTRACT: name + '/SAVE_PARTNERSHIP_CONTRACT',
    REGENERATE_PARTNERSHIP_CONTRACT: name + '/REGENERATE_PARTNERSHIP_CONTRACT',
    GET_PAYMENT_RULES: name + '/GET_PAYMENT_RULES',
    SET_PAYMENT_RULE: name + '/SET_PAYMENT_RULE',
};
